export enum ScanMode {
  Paint = 'paint',
  QRCode = 'qr-code',
}
